import { render, staticRenderFns } from "./Caregivers.vue?vue&type=template&id=6d9a02fc&scoped=true"
import script from "./Caregivers.vue?vue&type=script&lang=js"
export * from "./Caregivers.vue?vue&type=script&lang=js"
import style0 from "./Caregivers.vue?vue&type=style&index=0&id=6d9a02fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9a02fc",
  null
  
)

export default component.exports